import { namespaceActions } from 'modules/app-core/redux-utils'
import { NAME } from './constants'

const CAN_POST_NOTE = 'CAN_POST_NOTE'
const CLEAR_POST_NOTE = 'CLEAR_POST_NOTE'
const CONTACT_METHOD = 'CONTACT_METHOD'
const EXPAND_ALL = 'EXPAND_ALL'
const EXPAND_NOTE = 'EXPAND_NOTE'
const LOAD_NOTE = 'LOAD_NOTE'
const LOAD_NOTE_LIST = 'LOAD_NOTE_LIST'
const LOAD_POST_NOTE = 'LOAD_POST_NOTE'
const LOADING_NOTE = 'LOADING_NOTE'
const POSTING_NOTE = 'POSTING_NOTE'
const SET_DATE = 'SET_DATE'
const SET_FILTER_STR = 'SET_FILTER_STR'
const SET_NOTE_MAX = 'SET_NOTE_MAX'
const VALIDATE_POST_NOTE = 'VALIDATE_POST_NOTE'

export default namespaceActions(NAME)([
  CAN_POST_NOTE,
  CLEAR_POST_NOTE,
  CONTACT_METHOD,
  EXPAND_ALL,
  EXPAND_NOTE,
  LOAD_NOTE_LIST,
  LOAD_NOTE,
  LOAD_POST_NOTE,
  LOADING_NOTE,
  POSTING_NOTE,
  SET_DATE,
  SET_FILTER_STR,
  SET_NOTE_MAX,
  VALIDATE_POST_NOTE,
])
